(function () {
  'use strict';

  var banner = document.getElementById('CookieBanner');
  if (!banner) return;

  var backdrop = document.querySelector('[data-cookie-backdrop]');
  var choices = banner.querySelector('#CookieChoices');
  var manageButton = banner.querySelector('[data-cookie-manage]');
  var status = banner.querySelector('[data-cookie-status]');
  var preferencesChoice = banner.querySelector('[data-cookie-preferences-choice]');
  var analyticsChoice = banner.querySelector('[data-cookie-analytics-choice]');
  var marketingChoice = banner.querySelector('[data-cookie-marketing-choice]');
  var privacyApi = null;
  var lastTrigger = null;
  var apiUnavailable = false;
  var privacyReadyPublished = false;
  var preferenceStorageLocked = false;
  var saveTimer = null;
  var inertedElements = [];
  var inertObserver = null;
  var modalActive = false;
  var sharedModalConfig = {
    hiddenAttribute: true,
    lockScroll: true,
    closeOnEscape: false,
    trapFocus: true,
    focusSelector: '.fl-cookie__legend',
    restoreFocus: false,
    appendToBody: true,
    inertAttribute: true,
    isolateBackground: true
  };
  var unavailableMessage = 'Privacy choices couldn’t load. Reload the page or use your browser’s cookie controls.';
  var preferenceStorageKeys = [
    'lt_last_link',
    'theme',
    'recently_viewed_products',
    'sa-tool-tuner',
    'sa-tool-metronome',
    'sa-tool-metronome-presets',
    'sa-tool-metronome-stats',
    'sa-tool-fretboard',
    'ashe_fret_custom_shape_presets',
    'ashe_fret_workspace_A',
    'ashe_fret_workspace_B',
    'sa-tool-delay',
    'sa-tool-harmony',
    'sa-tool-generator',
    'ashe_generator_tracks',
    'ashe_generator_favorites_v1',
    'ashe_generator_daily_state_v1',
    'sa-tool-idea-state',
    'sa-tool-rhythm-trainer',
    'sa-tool-rhythm-trainer-settings',
    'sa-tool-warmup',
    'sa-tool-drone',
    'cart_email_captured',
    'persisted_cart',
    'popup_dismiss_count',
    'popup_last_dismiss_time',
    'popup_email_submitted',
    'popup_current_stage',
    'announcement-closed'
  ];

  window.flCanTrackMarketing = false;
  window.flCanTrackAnalytics = false;
  window.flCanTrackPreferences = false;
  window.flPrivacyReady = false;
  window.flRunWhenPrivacyReady = function (callback) {
    if (typeof callback !== 'function') return;
    if (window.flPrivacyReady) {
      callback();
      return;
    }
    document.addEventListener('fl:privacy-ready', callback, { once: true });
  };
  window.flPreferenceStorage = {
    getItem: function (key) {
      if (!window.flCanTrackPreferences) return null;
      try { return window.localStorage.getItem(key); } catch (error) { return null; }
    },
    setItem: function (key, value) {
      if (!window.flCanTrackPreferences) return false;
      try { window.localStorage.setItem(key, value); return true; } catch (error) { return false; }
    },
    removeItem: function (key) {
      try { window.localStorage.removeItem(key); return true; } catch (error) { return false; }
    }
  };

  function clearPreferenceStorage() {
    preferenceStorageKeys.forEach(function (key) {
      window.flPreferenceStorage.removeItem(key);
    });
  }

  function announce(message) {
    if (status) status.textContent = message || '';
  }

  function publishState(eventName) {
    if (eventName === 'fl:privacy-ready' && privacyReadyPublished) return;
    var detail = {
      analyticsAllowed: false,
      marketingAllowed: false,
      preferencesAllowed: false,
      saleOfDataAllowed: false
    };

    if (privacyApi) {
      try {
        detail.analyticsAllowed = privacyApi.analyticsProcessingAllowed();
        detail.marketingAllowed = privacyApi.marketingAllowed();
        detail.preferencesAllowed = privacyApi.preferencesProcessingAllowed();
        detail.saleOfDataAllowed = privacyApi.saleOfDataAllowed();
      } catch (error) {}
    }
    if (preferenceStorageLocked) detail.preferencesAllowed = false;

    window.flCanTrackMarketing = detail.marketingAllowed;
    window.flCanTrackAnalytics = detail.analyticsAllowed;
    window.flCanTrackPreferences = detail.preferencesAllowed;
    if (privacyApi) {
      try {
        if (privacyApi.currentVisitorConsent().preferences === 'no') clearPreferenceStorage();
      } catch (error) {}
    }
    if (eventName === 'fl:privacy-ready') {
      privacyReadyPublished = true;
      window.flPrivacyReady = true;
    }
    document.dispatchEvent(new CustomEvent(eventName, { detail: detail }));
  }

  function syncChoices() {
    if (!privacyApi) return;
    try {
      var current = privacyApi.currentVisitorConsent();
      preferencesChoice.checked = current.preferences === 'yes' || (current.preferences !== 'no' && privacyApi.preferencesProcessingAllowed());
      analyticsChoice.checked = current.analytics === 'yes' || (current.analytics !== 'no' && privacyApi.analyticsProcessingAllowed());
      marketingChoice.checked = current.marketing === 'yes' || (current.marketing !== 'no' && privacyApi.marketingAllowed());
    } catch (error) {}
  }

  function makeBackgroundElementInert(element) {
    if (!(element instanceof HTMLElement) || element === banner || element === backdrop) return;
    if (/^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(element.tagName) || element.hasAttribute('inert')) return;
    inertedElements.push({
      element: element,
      ariaHidden: element.getAttribute('aria-hidden')
    });
    element.setAttribute('inert', '');
    element.setAttribute('aria-hidden', 'true');
  }

  function restoreFallbackIsolation() {
    if (inertObserver) inertObserver.disconnect();
    inertedElements.forEach(function (record) {
      if (!record.element) return;
      record.element.removeAttribute('inert');
      if (record.ariaHidden === null) record.element.removeAttribute('aria-hidden');
      else record.element.setAttribute('aria-hidden', record.ariaHidden);
    });
    inertedElements = [];
  }

  function setModalState(active) {
    document.body.classList.toggle('fl-cookie-modal-open', active);
    if (backdrop) backdrop.hidden = !active;

    var modalController = window.SAModalController;
    if (active && modalController && typeof modalController.open === 'function') {
      restoreFallbackIsolation();
      modalActive = modalController.open(banner, sharedModalConfig);
      return;
    }

    if (!active && modalActive && modalController && typeof modalController.close === 'function') {
      modalController.close(banner, sharedModalConfig);
      modalActive = false;
      return;
    }

    if (active) {
      Array.prototype.forEach.call(document.body.children, makeBackgroundElementInert);
      if (!inertObserver) {
        inertObserver = new MutationObserver(function (records) {
          records.forEach(function (record) {
            Array.prototype.forEach.call(record.addedNodes, makeBackgroundElementInert);
          });
        });
      }
      inertObserver.observe(document.body, { childList: true });
      return;
    }

    restoreFallbackIsolation();
  }

  function show(trigger, manage) {
    lastTrigger = trigger || document.activeElement;
    syncChoices();
    banner.hidden = false;
    banner.removeAttribute('inert');
    banner.setAttribute('aria-hidden', 'false');
    banner.setAttribute('aria-modal', manage ? 'true' : 'false');
    choices.hidden = !manage;
    manageButton.setAttribute('aria-expanded', manage ? 'true' : 'false');
    var target = manage ? banner.querySelector('.fl-cookie__legend') : banner.querySelector('.fl-cookie__title');
    if (target) target.setAttribute('tabindex', '-1');
    // Expose the managed controls before the shared controller schedules focus.
    setModalState(Boolean(manage));
    announce(privacyApi ? '' : (apiUnavailable ? unavailableMessage : 'Loading privacy controls…'));
    if (target && !modalActive) {
      target.focus({ preventScroll: true });
    }
  }

  function hide(restoreFocus) {
    banner.hidden = true;
    banner.setAttribute('inert', '');
    banner.setAttribute('aria-hidden', 'true');
    banner.setAttribute('aria-modal', 'false');
    setModalState(false);
    choices.hidden = true;
    manageButton.setAttribute('aria-expanded', 'false');
    announce('');
    if (!restoreFocus) return;
    if (lastTrigger && lastTrigger !== document.body && !banner.contains(lastTrigger) && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus({ preventScroll: true });
      return;
    }
    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (main && typeof main.focus === 'function') {
      var hadTabindex = main.hasAttribute('tabindex');
      main.setAttribute('tabindex', '-1');
      main.focus({ preventScroll: true });
      if (!hadTabindex) main.addEventListener('blur', function cleanup() {
        main.removeAttribute('tabindex');
      }, { once: true });
    }
  }

  window.flOpenPrivacyChoices = function (trigger) {
    show(trigger || document.activeElement, true);
  };

  function setConsent(consent) {
    if (!privacyApi) {
      announce(apiUnavailable ? unavailableMessage : 'Privacy controls are still loading. Please try again in a moment.');
      return;
    }
    announce('Saving…');
    window.clearTimeout(saveTimer);
    saveTimer = window.setTimeout(function () {
      announce('Could not confirm that your choices were saved. Please try again.');
    }, 8000);
    try {
      privacyApi.setTrackingConsent(consent, function (result) {
        window.clearTimeout(saveTimer);
        if (result && result.error) {
          announce('Your choices were not saved. Please try again.');
          return;
        }
        if (consent.preferences === false) clearPreferenceStorage();
        syncChoices();
        publishState('fl:privacy-consent-change');
        announce('Choices saved.');
        window.setTimeout(function () { hide(true); }, 450);
      });
    } catch (error) {
      window.clearTimeout(saveTimer);
      announce('Your choices were not saved. Please try again.');
    }
  }

  banner.addEventListener('click', function (event) {
    var button = event.target.closest('button');
    if (!button) return;
    if (button.matches('[data-cookie-close]')) hide(true);
    if (button.matches('[data-cookie-manage]')) {
      choices.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      banner.setAttribute('aria-modal', 'true');
      setModalState(true);
      syncChoices();
      var legend = banner.querySelector('.fl-cookie__legend');
      if (legend) { legend.setAttribute('tabindex', '-1'); legend.focus(); }
    }
    if (button.matches('[data-cookie-back]')) {
      choices.hidden = true;
      manageButton.setAttribute('aria-expanded', 'false');
      banner.setAttribute('aria-modal', 'true');
      manageButton.focus();
    }
    if (button.matches('[data-cookie-essential]')) {
      setConsent({ preferences: false, analytics: false, marketing: false });
    }
    if (button.matches('[data-cookie-allow]')) {
      setConsent({ preferences: true, analytics: true, marketing: true });
    }
    if (button.matches('[data-cookie-save]')) {
      setConsent({
        preferences: preferencesChoice.checked,
        analytics: analyticsChoice.checked,
        marketing: marketingChoice.checked
      });
    }
  });

  banner.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      hide(true);
      return;
    }
    if (modalActive) return;
    if (event.key !== 'Tab' || banner.getAttribute('aria-modal') !== 'true') return;

    var focusable = Array.prototype.filter.call(
      banner.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (element) {
        return !element.hidden && element.getClientRects().length > 0;
      }
    );
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    var activeIndex = focusable.indexOf(document.activeElement);
    if (event.shiftKey && (document.activeElement === first || activeIndex === -1)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || activeIndex === -1)) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cookie-preferences]');
    if (!trigger) return;
    event.preventDefault();
    show(trigger, true);
  });

  document.addEventListener('visitorConsentCollected', function () {
    syncChoices();
    publishState('fl:privacy-consent-change');
  });

  window.Shopify = window.Shopify || {};
  if (typeof window.Shopify.loadFeatures !== 'function') {
    apiUnavailable = true;
    publishState('fl:privacy-ready');
    return;
  }

  var featureTimer = window.setTimeout(function () {
    apiUnavailable = true;
    preferenceStorageLocked = true;
    publishState('fl:privacy-ready');
    announce(unavailableMessage);
  }, 4000);

  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    function (error) {
      window.clearTimeout(featureTimer);
      if (error || !window.Shopify.customerPrivacy) {
        apiUnavailable = true;
        publishState('fl:privacy-ready');
        announce(unavailableMessage);
        return;
      }

      privacyApi = window.Shopify.customerPrivacy;
      apiUnavailable = false;
      preferenceStorageLocked = false;
      syncChoices();
      publishState(privacyReadyPublished ? 'fl:privacy-consent-change' : 'fl:privacy-ready');
      try {
        if (privacyApi.shouldShowBanner() && banner.hidden) show(null, false);
      } catch (apiError) {}
    }
  );
})();
